import React from "react";
import { Box, Grid, IconButton, Stack, Toolbar, Typography } from "@mui/material";
import { CloseRounded, MenuRounded, Minimize, OpenInFullRounded } from "@mui/icons-material";
import { useAiChat } from "../../provider/AiChatProvider";
import { CollapsableWindowProps } from "../CollapsableWindow/CollapsableWindow";
import aiChatToolbarStyles from "./aiChatToolbarStyles";

type AiChatToolbarProps = {
  windowState: CollapsableWindowProps["windowState"];
  setWindowState: React.Dispatch<React.SetStateAction<CollapsableWindowProps["windowState"]>>;
};

export default function AiChatToolbar({ windowState, setWindowState }: AiChatToolbarProps) {
  const { setHistoryOpen, activeAgent, resetAiChat } = useAiChat();

  return (
    <Toolbar
      sx={{
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.accent.main} 100%)`,
      }}
    >
      <Grid container sx={{ width: "100%" }}>
        <Grid size={10}>
          <Stack direction={"row"} spacing={2}>
            <IconButton onClick={() => setHistoryOpen((prevState) => !prevState)}>
              <MenuRounded sx={{ color: "primary.contrastText" }} />
            </IconButton>
            <Box>
              <Typography sx={{ color: "primary.contrastText" }}><strong>{activeAgent}</strong></Typography>
              <Box sx={aiChatToolbarStyles.statusCircle} />
              <Typography sx={{ color: "primary.contrastText" }} component={"span"}>
                Online
              </Typography>
            </Box>
          </Stack>
        </Grid>
        <Grid size={1}>
          {windowState === "maximized" && (
            <IconButton onClick={() => setWindowState("minimized")}>
              <Minimize sx={{ color: "primary.contrastText" }} />
            </IconButton>
          )}
          {windowState === "minimized" && (
            <IconButton onClick={() => setWindowState("maximized")}>
              <OpenInFullRounded sx={{ color: "primary.contrastText" }} />
            </IconButton>
          )}
        </Grid>
        <Grid size={1}>
          <IconButton onClick={() => resetAiChat()}>
            <CloseRounded sx={{ color: "primary.contrastText" }} />
          </IconButton>
        </Grid>
      </Grid>
    </Toolbar>
  );
}
